import axios, { AxiosResponse } from "axios";
import environment from "../config";
import SalaryData from "../entities/SalaryData";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export async function Get101ButtonIsAllowed() {
  try {   
    const path = environment.BASE_URL + "MemberDetails/Get101ButtonIsAllowed";
    const res: AxiosResponse<any> = await dal.post(path,null);   
  if (axiosUtil.isSuccess(res) && res?.data.errorCode === 0) {
      return true
  }
  else{
      return false
  }
  } catch (err) {
    console.log(err);
    return false
  }
}
